import { QUOTES_V2_BLOTTER_PREFIX } from '@src/containers/Blotters/QuotesV2/tokens';
import type { TabProps, TabsState } from '@talos/kyoko';
import { shouldRunBlotterTabsMigration } from '../../blotterTabsMigrationVersion';
import { migrateLegacyTabsIntoTradingBlotterPanels } from '../blotterTabsMigrationHelpers';
import type { AppConfigStateWithLegacyLayoutConfigs } from '../legacyLayoutConfigs.types';

const LEGACY_QUOTES_BLOTTER_PREFIX = 'principal/quotes';

function getLegacyRFQTabs(config: AppConfigStateWithLegacyLayoutConfigs) {
  const quotesV2Tabs = config.tabs?.[QUOTES_V2_BLOTTER_PREFIX];
  const quotesTabs = config.tabs?.[LEGACY_QUOTES_BLOTTER_PREFIX];

  if (quotesV2Tabs?.items?.length) {
    return quotesV2Tabs;
  }

  return quotesTabs ?? quotesV2Tabs;
}

/** Moves legacy RFQ tabs into RFQs blotter panel params. */
export function migrateRFQsBlotterTabsToPanelParams(initialConfig: unknown) {
  const config = initialConfig as AppConfigStateWithLegacyLayoutConfigs;
  if (!shouldRunBlotterTabsMigration(config)) {
    return;
  }
  const legacyRFQTabs = getLegacyRFQTabs(config);
  if (legacyRFQTabs == null) {
    return;
  }

  migrateLegacyTabsIntoTradingBlotterPanels(config, {
    legacyTabs: legacyRFQTabs as TabsState<TabProps>,
    blotterType: 'rfqsBlotter',
  });
}
